import { Environment } from '../environments';
import { buildBiwApiRootUri } from './buildBiwApiRootUri';
import { buildUri } from './utils/buildUri';

const CMX_SERVICE_PATH = '/v2/cmx';
const CMX_LOCALES_PATH = '/locales';

export const buildLocaleListUri = ( env ) => (
    buildUri(
        [ buildBiwApiRootUri( env ), CMX_SERVICE_PATH, CMX_LOCALES_PATH ],
        { env: ( env !== Environment.PROD ) ? env : '' },
    )
);
